import type { ServiceDeskAssetsImportType } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-assets-import-type-configuration", jiraSpaEntry: "async-resource-servicedesk-assets-import-type-configuration" */ './controllers/get-data'
	);

export const serviceDeskAssetsImportTypeForgeDataResource: RouteResource<
	ServiceDeskAssetsImportType[] | null
> = createResource<ServiceDeskAssetsImportType[] | null>({
	type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
	getKey: () => 'extensions',
	getDataLoader,
	maxAge: Number.MAX_SAFE_INTEGER,
	isBrowserOnly: true,
});
